<template>
  <div class="filter-elem1" v-click-outside="toggleSwitchClose">
    <span>{{ $t('select_region') }}</span>
    <div class="dropdown field" @click="toggleSwitch">
      <input :value="selectedRegion ? selectedRegion[0] : emptyRegionName" readonly />
      <button>
        <i class="svg-icon arrow-bold" :class="{ 'rotate-180': active }"></i>
      </button>
    </div>
    <slide-up-down :active="active" :duration="400" :responsive="true" class="filter-obj-list" @close-end="changeRegion">
      <div ref="regions_list" class="object-list">
        <div v-if="region">
          <a href="#" @click.prevent="selectRegion(null)">
            <span class="city-elem">{{ emptyRegionName }}</span>
          </a>
        </div>
        <div v-for="region in regions">
          <a href="#" @click.prevent="selectRegion(region)">
            <span class="city-elem">{{ region[0] }}</span>
          </a>
        </div>
      </div>
    </slide-up-down>
  </div>
</template>

<script>
import SlideUpDown from 'vue-slide-up-down';

export default {
  components: {
    SlideUpDown,
  },
  props: ['regions', 'region'],
  data() {
    return {
      active: false,
      emptyRegionName: 'Все регионы',
      selectedRegion: this.region,
    };
  },
  watch: {
    region(val) {
      this.selectedRegion = val;
    },
  },
  methods: {
    toggleSwitch() {
      this.active = !this.active;
    },
    toggleSwitchClose() {
      if (this.active) {
        this.active = false;
      }
    },
    changeRegion() {
      this.$emit('change', this.selectedRegion);
      if (this.$refs.regions_list) {
        this.$refs.regions_list.offsetParent.scrollTop = 0;
      }
    },
    selectRegion(region) {
      this.selectedRegion = region;
      this.toggleSwitch();
    },
  },
};
</script>

<i18n lang="yaml">
ru:
  select_region: 'Выберите регион'
en:
  select_region: 'Select region'
</i18n>
